import { Nullable } from "features/shared/types/nullable";
import { DynamicConfiguration, isDynamicConfiguration } from "./DynamicConfiguration";

declare const window: any;

let dynamicConfig: Nullable<DynamicConfiguration> = null;

export const getDynamicConfig = (): DynamicConfiguration => {
  if (dynamicConfig !== null) {
    return dynamicConfig;
  } else {
    let config = validateAndGetDynamicConfig();
    dynamicConfig = config;
    
    return config;
  }
};

const validateAndGetDynamicConfig = () => {
  const config = window.dynamicConfiguration;

  if (isDynamicConfiguration(config, true)) {
    return {
      ...config
    }
  } else {
    throw new Error("Configuration object is wrong.");
  }
}
